import { useEffect, useState } from 'react';
import { useFireAlarm } from '../state/useFireAlarm';
import { formatDateTime } from '../utils/date-format';
import './FireAlarmOverlay.css';

export function FireAlarmOverlay() {
  const { isFireAlarmActive, fireAlarm } = useFireAlarm();
  const [visible, setVisible] = useState(isFireAlarmActive);
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    if (isFireAlarmActive) {
      // Re-arming: drop any pending fade-out and show immediately.
      setFadingOut(false);
      setVisible(true);
      return;
    }
    if (!visible) return;
    // 0.3s fade-out when the alarm clears before unmounting so the
    // overlay doesn't pop off-screen.
    setFadingOut(true);
    const handle = window.setTimeout(() => {
      setVisible(false);
      setFadingOut(false);
    }, 300);
    return () => window.clearTimeout(handle);
  }, [isFireAlarmActive, visible]);

  if (!visible) return null;
  const ts = fireAlarm.lastSeen ? formatDateTime(fireAlarm.lastSeen) : 'unknown time';
  return (
    <div
      className={`nx-fire-overlay${fadingOut ? ' nx-fire-overlay--fading' : ''}`}
      role="alert"
      aria-live="assertive"
      data-testid="fire-alarm-overlay"
    >
      <div className="nx-fire-overlay__banner">
        <span className="nx-fire-overlay__pulse" aria-hidden="true" />
        <span className="nx-fire-overlay__text">FIRE ALARM ACTIVE — {ts}</span>
      </div>
    </div>
  );
}
